// export const cardNumPath = 'sc.B4.currData.orderData.payments.0'; // Só Numero Cartão vai pra esse caminho
// sc.B4.currData.orderData.payments.0
// sc.B4.currData.orderData.payments.0
export const cardNumPath = 'sc.B4.currData.orderData.payments.0'; // Só Numero Cartão vai pra esse caminho
export const checkoutPath = 'sc.B4.currData.checkout'; // Todos os demais dados (itens do pedido, valor etc)
export const cardTokenPath = 'all.userData.paymentData.id'; // Curr Auth User Payment Data
export const userDataPath = 'all.userData'; // Curr Auth User Payment Data

export const errorPathShow = 'all.apis.msgs.condShow'; // recebe 'true' ou 'false' (string)
export const errorPathTxt = 'all.apis.msgs.error'; // recebe texto de erro da resposta do servidor (string)
export const txtErrorDefault1 = 'Verifique todos os campos obrigatórios.';
